import { createContext, useContext, type ReactNode } from 'react'
import { shouldShowSingleNodeDetails } from './selectionDetails'

const SingleNodeDetailsContext = createContext(true)

interface SingleNodeDetailsProviderProps {
  selectedNodeCount: number
  /**
   * Hold single-node details closed regardless of the count.
   *
   * A marquee drag selects nodes as it sweeps, so the count passes through 1
   * on the way to N and every designer node's auto-open hook fires — the
   * config panel pops open mid-drag over a selection the user has not
   * finished making. Suppressing for the duration defers the decision to
   * mouse-up, when the count is final.
   */
  suppressed?: boolean
  children: ReactNode
}

export function SingleNodeDetailsProvider({
  selectedNodeCount,
  suppressed = false,
  children,
}: SingleNodeDetailsProviderProps) {
  const canShow = !suppressed && shouldShowSingleNodeDetails(selectedNodeCount)
  return (
    <SingleNodeDetailsContext.Provider value={canShow}>
      {children}
    </SingleNodeDetailsContext.Provider>
  )
}

export function useCanShowSingleNodeDetails(): boolean {
  return useContext(SingleNodeDetailsContext)
}
